// Foundations
import { Pipe, PipeTransform } from '@angular/core';

// JSON
import usStateList from 'src/assets/json/us-state-list.json';
import caProvinceList from 'src/assets/json/ca-province-list.json';

@Pipe({
  name: 'stateProvince'
})
export class StateProvincePipe implements PipeTransform {

  transform(stateAbbr: string, countryAbbr: 'us' | 'ca'): string {
    switch (countryAbbr) {
      case 'us':
        return usStateList.find(state => state.abbreviation === stateAbbr).fullName;
      case 'ca':
        return caProvinceList.find(province => province.abbreviation === stateAbbr).fullName;
      default:
        return 'N/A';
    }
  }

}
